import axios from 'axios';
import { ListResponse, Response, ResponseArray } from '../../../../setup/axios/HttpResponse';
import { API_URL } from '../../../utils/common/constants';
import { SearchBusyTimeRequest, BusyTimeListResponse } from '../models';
import { _convertObjectToQuery } from '../../../utils/helpers';
import { TimeSlotWorkingDay } from '../../busy-time/models/BusyTime';

const busyTimeApi = {
  searchBusyTime(body: SearchBusyTimeRequest): Promise<ListResponse<BusyTimeListResponse>> {
    const url = `${API_URL}/api/v1/busy-time-bus/search`;
    return axios.post(url, body);
  },
  // get time slots for Bus
  getTimeSlotsForBus(params: { lstSPId: string[], lstDateCheck: string[], timezone: number }): Promise<ResponseArray<TimeSlotWorkingDay>> {
    const url = `${API_URL}/api/v1/busy-time-bus/get-time-slot-working-day`;
    return axios.post(url, {
      ...params
    });
  },
  // get time slots for Worker
  getTimeSlotsForWorker(params: { lstWorkerId: string[], lstDateCheck: string[], timezone: number }): Promise<ResponseArray<TimeSlotWorkingDay>> {
    const url = `${API_URL}/api/v1/busy-time-worker/get-time-slot-working-day`;
    return axios.post(url, {
      ...params
    });
  },

  getBusyTimeDayForBus(params: { spId: string, timezone: number }): Promise<ResponseArray<string>> {
    const url = `${API_URL}/api/v1/busy-time-bus/get-busy-time-by-day?${_convertObjectToQuery(params)}`;
    return axios.get(url);
  },

  getBusyTimeDayForWorker(params: { workerId: string, timezone: number }): Promise<ResponseArray<string>> {
    const url = `${API_URL}/api/v1/busy-time-worker/get-busy-time-by-day?${_convertObjectToQuery(params)}`;
    return axios.get(url);
  },

  updateBusyTimeForBus(payload: any): Promise<Response<boolean>> {
    const url = `${API_URL}/api/v1/busy-time-bus/create`;
    return axios.post(url, payload);
  },

  updateBusyTimeForWorker(payload: any): Promise<Response<boolean>> {
    const url = `${API_URL}/api/v1/busy-time-worker/create`;
    return axios.post(url, payload);
  },

  resetAllBusyTimeForBus(spIds: string[]): Promise<Response<boolean>> {
    const url = `${API_URL}/api/v1/busy-time-bus/reset-all`;
    return axios.put(url, { SPId: spIds });
  },

  resetAllBusyTimeForWorker(workerIds: string[]): Promise<Response<boolean>> {
    const url = `${API_URL}/api/v1/busy-time-worker/reset-all`;
    return axios.put(url, { workerId: workerIds });
  },
};

export { busyTimeApi };

